import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { MapWallDisplayActions } from './map-wall-display.actions';
import { locationsWidgetDefaults } from './locations-widget-defaults';
import { timesWidgetDefaults } from './times-widget-defaults';

export const updateConfiguration = createEffect(
  (actions$ = inject(Actions), translate = inject(TranslateService)) =>
    actions$.pipe(
      ofType(MapWallDisplayActions.updateConfiguration),
      map(action => {
        const configuration = { ...action.configuration };

        // * NOTE * - both of these are same lists with different uids
        // TODO: investigate if we can reduce what is being stored in JSON (view both default variables for examples)
        if (configuration?.showLocations) {
          if (!configuration?.locations?.length) {
            configuration.locations = locationsWidgetDefaults.map(location => ({
              ...location,
              name: translate.instant(`MAP-DISPLAY.LOCATIONS.${location.code}`)
            }));
          }

          if (!configuration?.locationCardSettings?.showWorld) {
            configuration.locations = configuration.locations.filter(({ isWorld }) => !isWorld);
          } else if (configuration?.locationCardSettings?.showWorld && configuration.locations.every(({ isWorld }) => !isWorld)) {
            configuration.locations = [
              {
                uId: 'World', // uId doesn't actually need to be uId for location widget card. old component generated a new uId
                code: 'WORLD',
                name: translate.instant('MAP-DISPLAY.LOCATIONS.WORLD'),
                place: {
                  locality: 'World',
                  area: null,
                  country: null,
                  displayName: 'World'
                },
                isWorld: true,
                focusPoint: {
                  latitude: 17.7611,
                  longitude: -84.3984,
                  zoomLevel: 3.4
                }
              },
              ...configuration.locations
            ];
          }
        }

        if (configuration?.showTimes && !configuration?.times?.length) {
          configuration.times = timesWidgetDefaults.map(location => ({
            ...location,
            name: translate.instant(`MAP-DISPLAY.LOCATIONS.${location.code}`)
          }));
        }

        return MapWallDisplayActions.setConfiguration({ configuration });
      })
    ),
  { functional: true }
);
